export const Additional = () => {
  return (
    <div className="additional">
      <p className="additional__title">Додаткова інформація</p>
      <div className="additional__wrapper additional__wrapper--mobile">
        <div className="additional__thumb">
          <div className="additional__item">
            <p className="additional__text">Оновлено</p>
            <p className="additional__description">04.06.2026</p>
          </div>

          <div className="additional__item">
            <p className="additional__text">Встановлень</p>
            <p className="additional__description">20794</p>
          </div>
          <div className="additional__item">
            <p className="additional__text">Вік</p>
            <p className="additional__description">21+</p>
          </div>
        </div>
        <div className="additional__thumb">
          <div className="additional__item">
            <p className="additional__text">Розмір</p>
            <p className="additional__description">3,3 МБ</p>
          </div>
          <div className="additional__item">
            <p className="additional__text">Поточна версія</p>
            <p className="additional__description">2.3</p>
          </div>
          <div className="additional__item">
            <p className="additional__text">Розробник</p>
            <p className="additional__description">Mine Slot</p>
          </div>
        </div>
      </div>
      <div className="additional__wrapper additional__wrapper--desktop">
        <div className="additional__thumb">
          <div className="additional__item">
            <p className="additional__text">Оновлено</p>
            <p className="additional__description">04.06.2026</p>
          </div>
          <div className="additional__item">
            <p className="additional__text">Розмір</p>
            <p className="additional__description">3,3 МБ</p>
          </div>
          <div className="additional__item">
            <p className="additional__text">Встановлень</p>
            <p className="additional__description">20794</p>
          </div>
        </div>
        <div className="additional__thumb">
          <div className="additional__item">
            <p className="additional__text">Поточна версія</p>
            <p className="additional__description">2.3</p>
          </div>
          <div className="additional__item">
            <p className="additional__text">Вік</p>
            <p className="additional__description">21+</p>
          </div>
          <div className="additional__item">
            <p className="additional__text">Розробник</p>
            <p className="additional__description">Mine Slot</p>
          </div>
        </div>
      </div>
    </div>
  );
};
